import {
  DOCUMENT_TITLE_BRAND,
  DOCUMENT_TITLE_ENV_PREFIX,
  DOCUMENT_TITLE_SEGMENT_MAX_LENGTH,
  DOCUMENT_TITLE_SEPARATOR,
  DOCUMENT_TITLE_TRUNCATION_SUFFIX,
} from './constants'

export type DocumentTitleSegment = string | null | undefined | false

function truncateSegment(segment: string): string {
  const trimmed = segment.trim()
  if (trimmed.length <= DOCUMENT_TITLE_SEGMENT_MAX_LENGTH) return trimmed
  const head = trimmed.slice(
    0,
    DOCUMENT_TITLE_SEGMENT_MAX_LENGTH - DOCUMENT_TITLE_TRUNCATION_SUFFIX.length,
  )
  return `${head.trimEnd()}${DOCUMENT_TITLE_TRUNCATION_SUFFIX}`
}

export function formatDocumentTitle(
  segments: ReadonlyArray<DocumentTitleSegment>,
  unreadCount = 0,
): string {
  const cleaned = segments
    .filter((s): s is string => typeof s === 'string' && s.trim().length > 0)
    .map(truncateSegment)

  const body =
    cleaned.length > 0
      ? `${cleaned.join(DOCUMENT_TITLE_SEPARATOR)}${DOCUMENT_TITLE_SEPARATOR}${DOCUMENT_TITLE_BRAND}`
      : DOCUMENT_TITLE_BRAND

  const titled = unreadCount > 0 ? `(${unreadCount}) ${body}` : body

  return `${DOCUMENT_TITLE_ENV_PREFIX}${titled}`
}
